import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  Customer,
  MyOrder,
  Order,
  OrderBundle,
  OrderRow,
  OrderHotel,
  OrderLog,
  PaginatedOrderLogs,
  TransactionVM,
  OrderParkingVM,
  OrganizationParkingsVM,
  OrganizationDiscountCheckVM,
  EditOrganizationDiscountCheckRequest,
  OrganizationAdditionalServiceVM,
  EditOrganizationAdditionalServiceRequest,
  EditOrganizationParkingPricingRequest,
  OrganizationParkingPricingVM,
  EditOrderAdditionalServiceRequest,
  KeyTaskVM,
  VehicleDetailsVM,
  OrganizationVehiclesVM,
  OrganizationVehicleEdit,
  AirTagVM,
  OrderPaginationModel,
  AdditionalServicePaginationModel,
  TransactionPaginatedModel,
  GateMode,
  ParkingSession,
  LPRLogsRequestModel,
  VehicleLiveStatus
} from '../models/orderModel';
import { OneUsersPaginationModel } from '../models/OneModels';
import { DiscountParkingQuota, ParkingSite, ParkingVM } from '../models/parkingsite.model';
import { UserResultModel } from '../models/userResultModel';
import { MyConfigOrganization } from '../models/myConfig';
import { AuthService } from './auth.service';
import { OrganizationMemberModel } from '../models/OrganizationMemberModel';
import { log } from 'console';

@Injectable()
export class BackOfficeService {

  private hostPath: string = JSON.parse(environment.IDENTITY);
  public loading = true;
  public users: UserResultModel[] = new Array<UserResultModel>();
  private usersSubject: BehaviorSubject<UserResultModel[]> = new BehaviorSubject<UserResultModel[]>(
    new Array<UserResultModel>()
  );

  constructor(
    public router: Router,
    private authHttp: HttpClient,
    private http: HttpClient,
    private authService: AuthService
  ) {
  }

  public getLPRImages(organizationId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/getLPRImages/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(lprimages => {
        return lprimages;
      }),
      catchError(this.handleError)
    );
  }

  /**
   * Add services to an existing order
   * @param orderId The ID of the order
   * @param serviceIds Array of service IDs to add to the order
   */
  public createTransactionWithServices(model: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/createTransactionWithServices`;

    return this.authHttp.post(url, model, { headers }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  public sendMobileNotification(UserId: string | null, orderId: string | null, title: string, message: string, payload: string, commonNotificationType: string | null) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/sendMobileNotification`;
    let body = {
      UserId,
      orderId,
      title,
      message,
      payload,
      commonNotificationType
    };
    return this.authHttp.post<any>(URL, body).pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  public getOrganizations(organizationId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/organizations?organizationId=${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(organizations => {
        return organizations;
      }),
      catchError(this.handleError)
    );
  }

  public createOrUpdateOrganizationMemberRight(organizationId: string, model: any): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationMember?organizationId=${organizationId}`;
    return this.authHttp.post<any>(URL, model).pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  public getProblemOrders(organizationId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/problems?organizationId=${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(problemorders => {
        return problemorders;
      }),
      catchError(this.handleError)
    );
  }

  public getDashboardState(organizationId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/dashboardState/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(problems => {
        return problems;
      }),
      catchError(this.handleError)
    );
  }

  public checkIsOrderProblemSolved(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/checkIsOrderProblemSolved/${orderId}`;
    return this.authHttp.post<any>(URL, {}).pipe(
      map(order => {
        return order;
      }),
      catchError(this.handleError)
    );
  }

  public getDashBoardParkingData(organizationId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/DashBoardParkingData?organizationId=${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(data => {
        return data;
      }),
      catchError(this.handleError)
    );
  }

  public getDashBoardPlanningData(organizationId: string, from: string, to: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/DashBoardPlanningData?organizationId=${organizationId}&from=${from}&to=${to}`;
    return this.authHttp.get<any>(URL).pipe(
      map(data => {
        return data;
      }),
      catchError(this.handleError)
    );
  }

  // public getDashBoardPlanning24HData() {
  //   const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/DashBoardPlanning24HData`;
  //   return this.authHttp.get<any>(URL).pipe(
  //     map(data => {
  //       return data;
  //     }),
  //     catchError(this.handleError)
  //   );
  // }

  // public getDashBoardTransactionData() {
  //   alert('Remove this');
  //   const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/DashBoardTransactionData`;
  //   return this.authHttp.get<any>(URL).pipe(
  //     map(data => {
  //       return data;
  //     }),
  //     catchError(this.handleError)
  //   );
  // }

  public getDashBoardOrderData(organizationId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/DashBoardOrderData?organizationId=${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(data => {
        return data;
      }),
      catchError(this.handleError)
    );
  }

  public openGate(code: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/${code}`;
    return this.authHttp.get<any>(URL).pipe(
      map(openGate => {
        return openGate;
      }),
      catchError(this.handleError)
    );
  }

  public getOrganizationParkings(organizationId: string): Observable<any[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/organizationparkings/${organizationId}`;
    return this.http.get<any[]>(URL).pipe(
      map(parkingVMs => {
        return parkingVMs;
      }),
      catchError(this.handleError)
    );
  }


  public getOrganizationGates(organizationId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/getGates/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(gates => {
        return gates;
      }),
      catchError(this.handleError)
    );
  }

  public getOrganizationMaintenanceGates(organizationId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/Backoffice/MaintenanceGates/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(gates => {
        return gates;
      }),
      catchError(this.handleError)
    );
  }

  public openParkingGate(organizationId: string, externalId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/openGate/${organizationId}?gate=${externalId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(openGate => {
        return openGate;
      }),
      catchError(this.handleError)
    );
  }

  public showDriveUpQRCode(gateId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/LPR/showQRCode/${gateId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  private streamServerUrl = 'https://stream-server-test.mangocliff-b7a35cda.swedencentral.azurecontainerapps.io';

  public getCameraStreamUrl(cameraId: string) {
    // const token = 'backdoor:2025'; // test token
    const token = this.authService.getToken();
    return `${this.streamServerUrl}/api/playlist.m3u8?token=${token}&camera=${cameraId}`;
  }

  public getSurveillanceCameras() {
    const token = this.authService.getToken();
    return this.http.get<string[]>(
      `${this.streamServerUrl}/api/archive/cameras?token=${token}`
    ).pipe(catchError(() => of([])));
  }

  public getArchivePlaylistUrl(cameraId: string, startEpoch: number, endEpoch: number) {
    const token = this.authService.getToken();
    return `${this.streamServerUrl}/api/archive/playlist.m3u8?token=${token}&camera=${cameraId}&start=${startEpoch}&end=${endEpoch}`;
  }

  //GATE MODES
  public getGateMode(gateName: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/gateOpMode/${gateName}`;
    return this.authHttp.get<any>(URL).pipe(
      map(gateMode => {
        return gateMode;
      }),
      catchError(this.handleError)
    );
  }

  public setGateMode(gateName: string, opMode: GateMode): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/gateOpMode/${gateName}?opMode=${opMode}`;
    return this.authHttp.post<any>(URL, {}).pipe(
      map(gateMode => {
        return gateMode;
      }),
      catchError(this.handleError)
    );
  }

  public getOrganizationVehicleInfoByOrgId(orgId: string): Observable<OrganizationVehiclesVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/getVehicles/${orgId}`;
    return this.authHttp.get<OrganizationVehiclesVM[]>(URL).pipe(
      map(vehicle => {
        return vehicle;
      }),
      catchError(this.handleError)
    );
  }

  public getOrganizationVehicleInfoById(VehicleId: string): Observable<OrganizationVehiclesVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/getVehicle/${VehicleId}`;
    return this.authHttp.get<OrganizationVehiclesVM>(URL).pipe(
      map(vehicle => {
        return vehicle;
      }),
      catchError(this.handleError)
    );
  }

  public editOrganizationVehicleInfo(model: OrganizationVehicleEdit): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + `Shuttlebuss/Shuttlebuss.Service/backoffice/Vehicle`, model, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public deleteVehicle(vehicleId: string, organizationId: string): Observable<boolean> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/Vehicle/${organizationId}/${vehicleId}`;
    return this.authHttp.delete<boolean>(URL).pipe(
      map((response) => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  public getOrganizationOrderParkings(organizationId: string): Observable<OrganizationParkingsVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationorderparkings/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(data => {
        return data;
      }),
      catchError(this.handleError)
    );
  }

  public getOrganizationDiscountChecks(organizationId: string): Observable<OrganizationDiscountCheckVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationdiscountchecks/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(data => {
        return data;
      }),
      catchError(this.handleError)
    );
  }

  public saveOrganizationDiscountCheck(organizationId: string, model: EditOrganizationDiscountCheckRequest): Observable<any> {
    const data = { site: 'www.shuttlebuss.se' };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + `Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationdiscountchecks/${organizationId}`, model, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public getOrganizationParkingPrices(organizationId: string, parkingId: string): Observable<OrganizationParkingPricingVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationparkingproducts/${organizationId}/${parkingId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(data => {
        return data;
      }),
      catchError(this.handleError)
    );
  }

  public saveOrganizationParkingPrice(organizationId: string, model: EditOrganizationParkingPricingRequest): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + `Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationparkingproducts/${organizationId}/${model.id}`, model, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public bulkUpdateOrganizationParkingPrice(organizationId: string, model: EditOrganizationParkingPricingRequest[]): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + `Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationparkingproducts/${organizationId}`, model, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public getOrganizationAdditionalServices(organizationId: string): Observable<OrganizationAdditionalServiceVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationadditionalservices/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(data => {
        return data;
      }),
      catchError(this.handleError)
    );
  }

  public saveOrganizationAdditionalServices(organizationId: string, model: EditOrganizationAdditionalServiceRequest): Observable<any> {
    const data = { site: 'www.shuttlebuss.se' };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + `Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationadditionalservices/${organizationId}`, model, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public sendParkingLPRCheckedInSMS(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/sendParkingLPRCheckedInSMS/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public sendOrderSMS(type: string, orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/sendOrderSMS/${type}/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderNr(orderNr: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/getordernr/${orderNr}`;
    return this.authHttp.get<any>(URL).pipe(
      map(order => {
        return order;
      }),
      catchError(this.handleError)
    );
  }

  public getTransactionNr(transactionNr: string): Observable<TransactionVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/transactionnr/${transactionNr}`;
    return this.authHttp.get<TransactionVM>(URL).pipe(
      map(transaction => {
        return transaction;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderAdditionalServices(orderId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/OrderAdditionalServices/additionalservicesorderid/${orderId}`;
    return this.authHttp.get<TransactionVM>(URL).pipe(
      map(transaction => {
        return transaction;
      }),
      catchError(this.handleError)
    );
  }

  public editOrderAdditionalServices(model: EditOrderAdditionalServiceRequest, organizationId: string) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/organizationorderadditionalservicesedit/${organizationId}`;
    return this.authHttp
      .post<TransactionVM>(URL, model, { headers })
      .pipe(
        map(result => {
          return result;
        }),
        catchError(this.handleError)
      );
  }

  public orderPaymentReversal(transactionId: string): Observable<TransactionVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/orderpaymentreversal/${transactionId}`;
    return this.authHttp.get<TransactionVM>(URL).pipe(
      map(order => {
        return order;
      }),
      catchError(this.handleError)
    );
  }

  public orderPaymentReversalPartial(transactionId: string, amount: number): Observable<TransactionVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/orderpaymentreversalpartial/${transactionId}/${amount}`;
    return this.authHttp.get<TransactionVM>(URL).pipe(
      map(transaction => {
        return transaction;
      }),
      catchError(this.handleError)
    );
  }

  public orderPaymentReversalTransactionRow(transactionId: string, transactionRowId: string): Observable<TransactionVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/orderpaymentreversaltransactionrow/${transactionId}/${transactionRowId}`;
    return this.authHttp.get<TransactionVM>(URL).pipe(
      map(transaction => {
        return transaction;
      }),
      catchError(this.handleError)
    );
  }

  public getTransactionStatus(transactionId: string): Observable<TransactionVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/transactionStatus/${transactionId}`;
    return this.authHttp.get<TransactionVM>(URL).pipe(
      map(transaction => {
        return transaction;
      }),
      catchError(this.handleError)
    );
  }

  public getTransactions(orderId: string): Observable<TransactionVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/transactions/${orderId}`;
    return this.authHttp.get<TransactionVM[]>(URL).pipe(
      map(transactions => {
        return transactions;
      }),
      catchError(this.handleError)
    );
  }

  //Todo: move to BackOffice Service and implement organizationId
  public getOrderParkingCarId(carId: string, organizationId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/orderparkingcarid/${carId}/${organizationId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderparking => {
        return orderparking;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderParkingDetailsCarId(carId: string): Observable<OrderParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/orderparkingcarid/${carId}`;
    return this.http.get<OrderParkingVM>(URL).pipe(
      map(orderparking => {
        return orderparking;
      }),
      catchError(this.handleError)
    );
  }


  public hasBackOfficeModuleAccess(moduleName: string, organization: MyConfigOrganization): boolean {
    let result = false;
    if (organization == null || organization.config == null || organization.config.backOfficeModules == null) {
      return result;
    }
    for (let module of organization.config.backOfficeModules) {
      if (module.name == moduleName) {
        result = true;
      }
    }
    return result;
  }

  public updateOrderParkingAndShuttles(payload: any): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/updateOrderParkingAndShuttles`;
    return this.authHttp.post<any>(URL, payload).pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error('backoffice.service - Handled error: ' + errMsg);
    return observableThrowError(error);
    //Todo: How to handle this properly in component?
  }

  public setOrderStatusPaid(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/setorderstatuspaid?orderId=${orderId}`;
    return this.authHttp.get<Order>(URL).pipe(
      map(orderVM => {
        return orderVM;
      }),
      catchError(this.handleError)
    );
  }

  public setOrderStatusPaidCart(orderId: string, customPrice: string): Observable<any> {
    const url = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/cart/setorderstatuspaid?orderId=${orderId}&customPrice=${customPrice}`;
    return this.authHttp.get<any>(url).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getOrdersBetweenDate(organizationId: string, shuttleDateFrom: string, shuttleDateTo: string): Observable<MyOrder[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/getordersbetweendate?organizationId=${organizationId}&from=${shuttleDateFrom}&to=${shuttleDateTo}`;
    return this.http.get<MyOrder[]>(URL).pipe(
      map(orders => {
        return orders;
      }),
      catchError(this.handleError)
    );
  }

  public getOrdersWithAdditionalServicesBetweenDate(organizationId: string, shuttleDateFrom: string, shuttleDateTo: string): Observable<MyOrder[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/getorderswithadditionalservicesbetweendate/${organizationId}/${shuttleDateFrom}/${shuttleDateTo}`;
    return this.http.get<MyOrder[]>(URL).pipe(
      map(orders => {
        return orders;
      }),
      catchError(this.handleError)
    );
  }

  public getOrder(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/getorder?orderId=${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(order => {
        return order;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderBundle(orderId: string): Observable<OrderBundle[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/getorderbundles?orderId=${orderId}`;
    return this.authHttp.get<OrderBundle[]>(URL).pipe(
      map(orderBundle => {
        return orderBundle;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderLogsPaginated(orderId: string, page: number, perPage: number): Observable<PaginatedOrderLogs> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/orderlogs?orderId=${orderId}&page=${page}&perpage=${perPage}`;
    return this.authHttp.get<PaginatedOrderLogs>(URL).pipe(
      map(response => response),
      catchError(this.handleError)
    );
  }

  public getOrderRows(orderId: string): Observable<OrderRow> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/getorderrows?orderId=${orderId}`;
    return this.authHttp.get<OrderRow>(URL).pipe(
      map(orderRow => {
        return orderRow;
      }),
      catchError(this.handleError)
    );
  }

  public getKeyTasks(organisationId: string, type: string): Observable<KeyTaskVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/getKeyTasks/${organisationId}?type=${type}`;
    return this.authHttp.get<KeyTaskVM[]>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public markDriverTaskDone(organisationId: string, OrderLockerId: string): Observable<boolean> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/KeyTaskIsDone/${organisationId}/${OrderLockerId}`;
    return this.authHttp.post<boolean>(URL, {}).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public markKeyTakenFromCustomerDone(organisationId: string, OrderLockerId: string): Observable<boolean> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/Backoffice/KeyIsTaken/${organisationId}/${OrderLockerId}`;
    return this.authHttp.post<boolean>(URL, {}).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public markAdminTaskDone(organisationId: string, OrderLockerId: string): Observable<boolean> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/openLocker/${organisationId}/${OrderLockerId}`;
    return this.authHttp.post<boolean>(URL, {}).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public takeKeyFromCustomerNoAS(organisationId: string, orderId: string): Observable<boolean> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/takeKeyWithNoAS/${organisationId}/${orderId}`;
    return this.authHttp.post<boolean>(URL, {}).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderKeyTasks(orderId: string): Observable<KeyTaskVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/KeyTasksStatus/${orderId}`;
    return this.authHttp.get<KeyTaskVM[]>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }
  public getAirtagList(organisationId: string): Observable<AirTagVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/getAirtagList/${organisationId}`;
    return this.authHttp.get<AirTagVM[]>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public tagAirtag(organisationId: string, orderId: string, airtagId: string, additionalServiceId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/TagAirtag/${organisationId}/${orderId}/${airtagId}/${additionalServiceId}`;
    return this.authHttp.post<any>(URL, {}).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public untagAirtag(organisationId: string, orderId: string, additionalServiceCompleted: boolean): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/UntagAirtag/${organisationId}/${orderId}?result=${additionalServiceCompleted}`;
    return this.authHttp.post<any>(URL, {}).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderVehicleDetails(RegNo: string, type: string): Observable<VehicleDetailsVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/getVehicleInfo/${RegNo}?type=${type}`;
    return this.authHttp.get<VehicleDetailsVM>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public addOrderRow(orderId: string, customerId: string, extraDays: string, insuranceCost: number): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/addorderrownew/${orderId}/${customerId}/${extraDays}/${insuranceCost}`;
    return this.authHttp.get<any>(URL).pipe(
      map(cart => {
        return cart;
      }),
      catchError(this.handleError)
    );
  }

  public getTransactionsBetweenCreated(organizationId: string, dateFrom: string, dateTo: string): Observable<TransactionVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/transactions/${organizationId}/${dateFrom}/${dateTo}`;
    return this.http.get<TransactionVM[]>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getTransactionsPaginated(organizationId: string, transactionPaginatedModel: TransactionPaginatedModel): Observable<TransactionVM[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/Backoffice/transactions/${organizationId}`;
    return this.http.post<TransactionVM[]>(URL, transactionPaginatedModel).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public setOrderstatusCancel(orderId: string, repayMoney: boolean = false): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/setorderstatuscancel/${orderId}?repayMoney=${repayMoney}`;
    return this.authHttp.get<Order>(URL).pipe(
      map(orderVM => {
        return orderVM;
      }),
      catchError(this.handleError)
    );
  }

  public orderPaymentCapture(orderId: string): Observable<Order> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/orderpaymentcapture/${orderId}`;
    return this.authHttp.get<Order>(URL).pipe(
      map(order => {
        return order;
      }),
      catchError(this.handleError)
    );
  }

  public sendOrderConfirmation(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/sendOrderConfirmation/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public sendDebtReminder(orderId: string, reminderNr: number): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/senddebtreminder/${orderId}/${reminderNr}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public sendOrderAdditionalPayment(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/sendorderadditionalpayment/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public sendVingOrderConfirmation(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/sendvingorderconfirmation/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public sendOrderAdditionalServiceOffer(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/sendorderadditionalserviceoffer/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public updateParkingSite(organizationId: string, parkingSpotId: string, active: boolean, withChildren: boolean = false): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/changeparkingspotstatus/${organizationId}/${parkingSpotId}/${active}?withChildren=${withChildren}`;
    return this.authHttp.get<any>(URL, {}).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getParkingDiscountQuotas(organizationId: string, parkingId: string): Observable<DiscountParkingQuota[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/parkingdiscountquotas/${organizationId}/${parkingId}`;
    return this.authHttp.get<DiscountParkingQuota[]>(URL).pipe(catchError(this.handleError));
  }

  // Replaces all quotas of the parking with the given list
  public saveParkingDiscountQuotas(organizationId: string, parkingId: string, quotas: DiscountParkingQuota[]): Observable<DiscountParkingQuota[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/parkingdiscountquotas/${organizationId}/${parkingId}`;
    return this.authHttp.post<DiscountParkingQuota[]>(URL, quotas).pipe(catchError(this.handleError));
  }

  public updateParkingInfo(parking: ParkingVM): Observable<ParkingVM> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/EditOrganizationParking/${parking.organizationId}`;
    return this.authHttp.post<ParkingVM>(URL, parking).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getPaginatedOrders(organizationId: string, orderPaginationModel: OrderPaginationModel): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/ordersIndex/${organizationId}`;
    return this.authHttp.post<any>(URL, orderPaginationModel).pipe(
      map(orders => {
        orders.data.forEach((order: any) => {
          if (order.paymentReference) {
            order.paymentReference = JSON.parse(order.paymentReference);
          }
        });
        return orders;
      }),
      catchError(this.handleError)
    );
  }

  public getPaginatedDebts(organizationId: string, orderPaginationModel: OrderPaginationModel): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/debtsIndex/${organizationId}`;
    return this.authHttp.post<any>(URL, orderPaginationModel).pipe(
      map(orders => {
        return orders;
      }),
      catchError(this.handleError)
    );
  }

  public getPaginatedAdditionalServiceTasks(organizationId: string, additionalServicePaginationModel: Partial<AdditionalServicePaginationModel>): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/orderAdditionalServicesindex/${organizationId}`;
    return this.authHttp.post<any>(URL, additionalServicePaginationModel).pipe(
      map(additionalServiceTasks => {
        // additionalServiceTasks.data.forEach(additionalServiceTask => {
        // additionalServiceTask.paymentReference = JSON.parse(additionalServiceTask.paymentReference);
        // });
        return additionalServiceTasks;
      }),
      catchError(this.handleError)
    );
  }

  public createCheckoutAdditional(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/createcheckoutadditional/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(paymentResponse => {
        return paymentResponse;
      }),
      catchError(this.handleError)
    );
  }

  public createOrUpdateOrganization(organizationId: string, model: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + `Shuttlebuss/Shuttlebuss.Service/backoffice/organization?organizationId=${organizationId}`, model, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public createOrUpdateOrganizationParkingAccess(organizationId: string, model: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + `Shuttlebuss/Shuttlebuss.Service/backoffice/organizationparkingaccess?organizationId=${organizationId}`, model, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public createOrUpdateOrganizationMember(organizationId: string, model: OrganizationMemberModel): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + `Shuttlebuss/Shuttlebuss.Service/backoffice/organizationMember?organizationId=${organizationId}`, model, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public deleteTransaction(orderId: string, transactionId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/transactiondelete/${orderId}/${transactionId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public loadUsers(): Observable<any> {
    const data = { site: 'www.shuttlebuss.se' };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/User/Users', data, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public getOneOrganizations(): Observable<any> {
    const data = { site: 'www.shuttlebuss.se' };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.authHttp
      .post<any>(this.hostPath + 'identity/one/organizations', data, {
        headers
      })
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public getOneUsers(userPaginationModel: OneUsersPaginationModel): Observable<any> {
    return this.authHttp
      .post<any>(this.hostPath + 'identity/one/users', userPaginationModel)
      .pipe(
        map((result: any) => result),
        catchError(this.handleError)
      );
  }

  public editOrderHotel(orderHotel: OrderHotel): Observable<OrderHotel> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/admin/editorderhotel';
    return this.authHttp
      .post<OrderHotel>(url, orderHotel, { headers })
      .pipe(
        map(result => {
          return result;
        }),
        catchError(this.handleError)
      );
  }

  public getOrderParking(orderParkingId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/orderparking/${orderParkingId}`;
    return this.http.get<any>(URL).pipe(
      map(orderparking => {
        return orderparking;
      }),
      catchError(this.handleError)
    );
  }

  public sendOrderParkingCheckinConfirmation(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/SendOrderParkingCheckinConfirmation/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public sendOrderWelcomeHome(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/SendOrderWelcomeHome/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public sendOrdeCancel(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/SendOrderCancel/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }
  public createInvoice(orderId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/createInvoice/${orderId}`;
    return this.authHttp.post<any>(URL, {}).pipe(
      map(status => {
        return status;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderHotel(orderId: string): Observable<ParkingSite> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderhotel/orderhotelsorderid/${orderId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  //Change name?
  public editOrder(customer: Customer) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/editcustomer/`;
    return this.authHttp.post<Customer>(URL, customer).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  getParkingSession(organizationId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/parkingSessions/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  createParkingSession(organizationId: string, body: ParkingSession) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/parkingSessions/${organizationId}`;
    return this.authHttp.post<any>(URL, body).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  getCameras(organizationId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/getCameras/${organizationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  getAllCameras() {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/getCameras`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => result),
      catchError(this.handleError)
    );
  }

  executeDisplayTest(url: string) {
    return this.authHttp.get<any>(url).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getLprLogs(organizationId: string, model: LPRLogsRequestModel) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/lprlogindex/${organizationId}`;
    return this.authHttp.post<any>(URL, model).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getAdditionalServicesTimeslots(organizationId: string, fromDate: string, toDate: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/additionalServicesTimeslots/${organizationId}/${fromDate}/${toDate}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getScheduleAssignment(additionalServiceId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/scheduleAssignment/${additionalServiceId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public createScheduleAssignment(model: any) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/scheduleAssignment`;
    return this.authHttp.post<any>(URL, model).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public deleteScheduleAssignment(additionalServiceId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/scheduleAssignment/${additionalServiceId}`;
    return this.authHttp.delete<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getScheduleTemplates(additionalServiceId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/scheduleTemplate/${additionalServiceId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public addUpdateScheduleAssignment(model: any) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/scheduleTemplate`;
    return this.authHttp.put<any>(URL, model).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public deleteScheduleTemplate(scheduleTemplateId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/scheduleTemplate/${scheduleTemplateId}`;
    return this.authHttp.delete<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getRouteScheduleTemplates() {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/routeScheduleTemplates`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public duplicateRouteScheduleTemplate(templateId: string, name: string, splitDate: string, dateTo: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/routeScheduleTemplates/duplicate`;
    return this.authHttp.post<any>(URL, { templateId, name, splitDate, dateTo }).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public deleteRouteScheduleTemplate(templateId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/routeScheduleTemplates/${templateId}`;
    return this.authHttp.delete<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public createRouteScheduleOverride(routeId: string, name: string, slots: any[], type: string, options: {
    date?: string, dayOfWeek?: string, dateFrom?: string, dateTo?: string
  }) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/routeScheduleTemplates/override`;
    return this.authHttp.post<any>(URL, {
      routeId, name, slots, type,
      date: options.date,
      dayOfWeek: options.dayOfWeek,
      dateFrom: options.dateFrom,
      dateTo: options.dateTo
    }).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public updateRouteScheduleOverride(templateId: string, name: string, slots: any[], type: string, options: {
    date?: string, dayOfWeek?: string, dateFrom?: string, dateTo?: string
  }) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/routeScheduleTemplates/override/${templateId}`;
    return this.authHttp.put<any>(URL, {
      name, slots, type,
      date: options.date,
      dayOfWeek: options.dayOfWeek,
      dateFrom: options.dateFrom,
      dateTo: options.dateTo
    }).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public rescheduleShuttles(shuttleIds: string[], newSwedishTime: string, notifyCustomer: boolean) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/rescheduleShuttles`;
    return this.authHttp.patch<any>(URL, { shuttleIds, newSwedishTime, notifyCustomer }).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getLPRLogDetailsById(organizationId: string, LPRLogId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/lprlogs/${organizationId}/${LPRLogId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

  public getInvoices(filter: any) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/invoiceIndex`;
    return this.authHttp.post<any>(URL, filter).pipe(
      map(result => result),
      catchError(this.handleError)
    );
  }

  public getInvoicesPaginated(requestBody: any): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/invoiceIndex`;
    return this.authHttp.post<any>(URL, requestBody).pipe(
      map(response => {
        return response;
      }), catchError(this.handleError)
    );
  }

  public getLPRCameraStatuses() {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/GetLPRCameraStatuses`;
    return this.authHttp.get<any[]>(URL).pipe(
      map(result => result),
      catchError(this.handleError)
    );
  }

  public getUnorderedParkings(organisationId: string) {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/backoffice/unorderedParkings/${organisationId}?period=15`;
    return this.authHttp.get<any>(URL).pipe(
      map(result => result),
      catchError(this.handleError)
    );
  }

  public addAdditionalServicesToOrder(orderId: string, serviceIds: number[], shouldBePaid: boolean): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/addAdditionalServicesToOrder`;
    const requestBody = { orderId, serviceIds, shouldBePaid };
    return this.authHttp.post<any>(URL, requestBody).pipe(
      map(response => {
        return response;
      }), catchError(this.handleError)
    );
  }

  public getOverlappingParkings(organisationId: string): Observable<any> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/BackOffice/overlappingMap/${organisationId}`;
    return this.authHttp.get<any>(URL).pipe(
      map(response => {
        return response;
      }), catchError(this.handleError)
    );
  }

  public getVehicleTrackingLive(): Observable<VehicleLiveStatus[]> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/VehicleTracking/live`;
    return this.authHttp.get<VehicleLiveStatus[]>(URL).pipe(
      map(response => response),
      catchError(this.handleError)
    );
  }

}
